/**
 * Password complexity is increased according to NIM-19044
 * the requirements are as described by the following message:
 */
export const PASSWORD_COMPLEXITY_MESSAGE = `Password complexity must including at least a single character from 3 of the following 5 character sets:
    a) Capital Letters (A-Z)
    b) Lowercase Letters (a-z)
    c) Numerals (0-9)
    d) Non-Alphanumeric/Special ASCII Characters: !"#$%&'()*+,-./:;<=>[|]
    e) Non-ASCII Alphabetic Characters (any Unicode character categorized as alphabetic that isn't included above; this includes printable Unicode characters from Asian languages).`;

// Step 1) Define the 5 character sets
const UPPER = String.raw`[A-Z]`; // a) Capital Letters
const LOWER = String.raw`[a-z]`; // b) Lowercase Letters
const DIGIT = String.raw`[0-9]`; // c) Numerals
const SPECIAL = String.raw`[!"#$%&'()*+,\-./:;<=>\[\|\]]`; // d) Non-Alphanumeric/Special ASCII Characters: ! " # $ % & ' ( ) * + , - . / : ; < = > [ | ]
const NON_ASCII_ALPHA = String.raw`(?![A-Za-z])\p{Alphabetic}`; // e) Non-ASCII Alphabetic Characters (Unicode alphabetic, but not A-Z/a-z),  requires the `u` flag

// Step 2) Build “has at least one from set X” lookaheads
const hasUpper = String.raw`(?=.*${UPPER})`;
const hasLower = String.raw`(?=.*${LOWER})`;
const hasDigit = String.raw`(?=.*${DIGIT})`;
const hasSpecial = String.raw`(?=.*${SPECIAL})`;
const hasNonAsciiAlpha = String.raw`(?=.*${NON_ASCII_ALPHA})`;

// Step 3) Require at least 1 char from ANY 3 of the 5 sets (10 combinations)
const any3of5 = String.raw`(?:${[
  // UPPER + LOWER + DIGIT
  `${hasUpper}${hasLower}${hasDigit}`,
  // UPPER + LOWER + SPECIAL
  `${hasUpper}${hasLower}${hasSpecial}`,
  // UPPER + LOWER + NON_ASCII_ALPHA
  `${hasUpper}${hasLower}${hasNonAsciiAlpha}`,
  // UPPER + DIGIT + SPECIAL
  `${hasUpper}${hasDigit}${hasSpecial}`,
  // UPPER + DIGIT + NON_ASCII_ALPHA
  `${hasUpper}${hasDigit}${hasNonAsciiAlpha}`,
  // UPPER + SPECIAL + NON_ASCII_ALPHA
  `${hasUpper}${hasSpecial}${hasNonAsciiAlpha}`,
  // LOWER + DIGIT + SPECIAL
  `${hasLower}${hasDigit}${hasSpecial}`,
  // LOWER + DIGIT + NON_ASCII_ALPHA
  `${hasLower}${hasDigit}${hasNonAsciiAlpha}`,
  // LOWER + SPECIAL + NON_ASCII_ALPHA
  `${hasLower}${hasSpecial}${hasNonAsciiAlpha}`,
  // DIGIT + SPECIAL + NON_ASCII_ALPHA
  `${hasDigit}${hasSpecial}${hasNonAsciiAlpha}`,
].join('|')})`;

// Step 4) Full regex: anchors + "any 3-of-5" + accept any characters in the string
export const securePasswordRegex = new RegExp(
  String.raw`^` + any3of5 + String.raw`[\s\S]*$`,
  'u', // required for \p{Alphabetic}
);
